import { render, staticRenderFns } from "./DeliveryNoteConfiguration.vue?vue&type=template&id=93131dc6"
import script from "./DeliveryNoteConfiguration.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNoteConfiguration.vue?vue&type=style&index=0&id=93131dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports